import { MessageDirection, wrap } from "./shared";
const debug = (...args)=>{
    console.log(...args);
};
export const buildAndroidTransport = ()=>{
    return new AndroidTransport();
};
class AndroidTransport {
    postMessage(messages) {
        debug("attempting to send", messages);
        //@ts-ignore
        if (typeof SWAndroid !== "undefined") {
            const wrappedOutgoingMessage = wrap(messages, MessageDirection.FromPaywall);
            debug("wrapped message", wrappedOutgoingMessage);
            //@ts-ignore
            SWAndroid.postMessage(wrappedOutgoingMessage);
            return;
        }
        debug("unable to send message");
    }
    _handlers = [];
    addListener(handler) {
        this._handlers.push(handler);
    }
    _listening = false;
    startListening() {
        this._listening = true;
    }
    accept(message) {
        if (this._listening) {
            this._handlers.forEach((handler)=>handler(message));
        }
    }
}
